import request from '@/utils/request'

const community = {
  name: 'community',
  state: {
    isCommunityDetailLoading: false,
    communityDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_COMMUNITY_DETAIL_LOADING: (state, data) => {
      state.isCommunityDetailLoading = data
    },
    SET_MODULES_COMMUNITY_DETAIL_DATA: (state, data) => {
      state.communityDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryCommunityDetailData({ commit }, id) {
      commit('SET_IS_MODULES_COMMUNITY_DETAIL_LOADING', true)
      commit('SET_MODULES_COMMUNITY_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/community/communityDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_COMMUNITY_DETAIL_LOADING', false)
          commit('SET_MODULES_COMMUNITY_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_COMMUNITY_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetCommunityDetailData({ commit }) {
      commit('SET_MODULES_COMMUNITY_DETAIL_DATA', {})
    },
    setCommunityDetailData({ commit }, data) {
      commit('SET_MODULES_COMMUNITY_DETAIL_DATA', data)
    },
    // 加载社区下拉列表
    queryCommunityNoPageList({ commit }, isAll) {
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/community/communityNoPageList',
          method: 'post',
        }).then(response => {
          for (const item of response.data) {
            item.label = item.name
            item.value = item.id
          }
          if (isAll) {
            response.data.unshift({label: '全部', value: ''})
          }
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default community
